import React, { useState, useEffect } from "react";
import { Route, Redirect, Switch } from "react-router-dom";

import asyncRoute from "../../helpers/hoc/asyncRoute";
import routes from "../../routes";
import { checkPermission, PrivateRoute } from "../../utils/route-auth";
import { MODULE_PERMISSIONS } from "../../constants/permission";

const Ro = asyncRoute(() => import("./RO"));
const Unmapped = asyncRoute(() => import("./UNMAPPEDCAMPAIGN"));
const NotAuthorize = asyncRoute(()=>import("../NotAuthorize"));

const permissionArray = [
  MODULE_PERMISSIONS.RO,
  MODULE_PERMISSIONS.UNMAPPEDCAMPAIGN,
];

const Goals = (props) => {
  const [paths, setPaths] = useState("");

  useEffect(() => {
    checkPathPermissions();
  }, [props.location.pathname]);

  const checkPathPermissions = () => {
    let availablePermissions = permissionArray
      .map((item) => checkPermission({ permissions: item }))
      .filter((item) => item !== undefined);
    if (availablePermissions.length > 0) {
      let defaultPathArr = availablePermissions[0].split("::");
      let path = defaultPathArr[defaultPathArr.length - 1]
        .trim()
        .toLowerCase()
        .replaceAll(" ", "-");
      if (path == "unmapped") {
        setPaths("unmapped-campaign");
      } else {
        setPaths('goals-list');
      }
    } else {
      setPaths("not-authorize");
      // setPaths('tenant');
    }
  };

  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${props.match.path}/${routes.containers.ro}`}
          component={Ro}
          permissions={MODULE_PERMISSIONS.RO}
          defaultRoute={"goals-list"}
        />

        <PrivateRoute
          path={`${props.match.path}/${routes.containers.unmappedCampaign}`}
          component={Unmapped}
          permissions={MODULE_PERMISSIONS.UNMAPPEDCAMPAIGN}
          defaultRoute={"unmappedCampaign"}
        />

        <Route
          exact
          path={`${props.match.path}`}
          render={() => <Redirect to={`${props.match.path}/${paths}`} />}
        />

        <Route path={`${props.match.path}/${routes.notAuthorize}`} component={NotAuthorize} />
      </Switch>
    </>
  );
};

export default Goals;
